import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import FieldType from "@mapmycustomers/shared/enum/fieldModel/FieldType";
import FilterOperator from "@mapmycustomers/shared/enum/FilterOperator";

import EmptyFilter from "@app/util/filters/EmptyFilter";
import RoutesFilter, { ROUTES_FILTER_OPERATORS } from "@app/util/filters/Routes";

import Field, { FieldProperties } from "./Field";
import { listFormatter } from "./fieldUtil";

class RoutesField extends Field {
  constructor(data: Omit<FieldProperties, "type">) {
    super({
      customFilterConfig: {
        defaultInstance: "routes",
        disallowedConjunctions: ["OR"],
        filterInstances: {
          empty: EmptyFilter,
          routes: RoutesFilter,
        },
        oneOccurrenceOnly: true,
        operators: [
          ...ROUTES_FILTER_OPERATORS,
          { instance: "empty", operator: FilterOperator.EMPTY },
          { instance: "empty", operator: FilterOperator.NOT_EMPTY },
        ],
        topLevelOnly: true,
      },
      customGridProperties: {
        cellRenderer: "routesCellRenderer",
      },

      extraPlatformFiltersGetter: () => ({ includeRoutes: true }),
      features: [
        FieldFeature.DATA_VIEW,
        FieldFeature.FILTERABLE_ON_MAP,
        FieldFeature.FILTERABLE,
        FieldFeature.NON_INTEGRATION,
        FieldFeature.NON_ADDABLE_FORM_FIELD,
        FieldFeature.NON_IMPORT,
        FieldFeature.RELATIONSHIPS_CATEGORY,
        FieldFeature.ROUTE_FIELD,
        FieldFeature.SUPPORTS_SET_FILTER,
        FieldFeature.VISIBLE_BY_DEFAULT,
      ],
      type: FieldType.LIST,
      valueFormatter: listFormatter("name"),
      ...data,
    });
  }

  get isCustomizableField() {
    // Route field is an exclusion - it shouldn't be present on list view, but available for selection in
    // entity records preview customization window
    return true;
  }
}

export default RoutesField;
